import { useCallback, useState } from 'preact/hooks';
import { useApi } from '../hooks/api';
import { prStore } from '../stores/pr';
import { baseBranch } from '../util/consts';
import { FlashMessage, flash } from './flash-message';

export const AddRecordToPrWidget = () => {
    const api = useApi();
    const [slugToUpdate, setSlugToUpdate] = useState('');
    const [isFetchingCompany, setIsFetchingCompany] = useState(false);

    const handleAddCompanyToUpdate = useCallback(async () => {
        if (!slugToUpdate || !api) return;
        setIsFetchingCompany(true);

        try {
            const filename = `companies/${slugToUpdate.replace('.json', '')}.json`;
            const content = await api.getFileContent({
                repository: api.repository,
                path: filename,
                ref: baseBranch,
            });
            prStore.set.addFileForUpdate(filename, content);
            setSlugToUpdate('');
        } catch (err) {
            flash(<FlashMessage type="error">Failed to load company to update: {(err as Error).message}</FlashMessage>);
        } finally {
            setIsFetchingCompany(false);
        }
    }, [slugToUpdate, api]);

    return (
        <div className="d-flex justify-content-between mb-3">
            <button className="btn btn-primary" onClick={() => prStore.set.addNewFile()}>
                Add new company
            </button>

            <div className="input-group w-50">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Company slug to update"
                    value={slugToUpdate}
                    onInput={(e) => setSlugToUpdate(e.currentTarget.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleAddCompanyToUpdate()}
                />
                <button
                    className="btn btn-secondary"
                    onClick={handleAddCompanyToUpdate}
                    disabled={!slugToUpdate || isFetchingCompany}>
                    {isFetchingCompany ? 'Loading…' : 'Update existing company'}
                </button>
            </div>
        </div>
    );
};
